module.exports = __webpack_public_path__ + "img/fu-wu-2.5c9454fe.png";